<template>
  <div class="belowCourseDetailsBox">
    <Download></Download>
    <div class="mainBox">
      <Cousertop
        :courseType="courseType"
        v-on:courseTopCallback="courseTopCallback"
        :info="info"
        :classesList="classesList"
      ></Cousertop>
      <div class="content">
        <div
          class="nav"
          ref="nav"
        >
          <span
            :class="navIndex == index ? 'active' : ''"
            v-for="(item, index) in navList"
            :key="index"
            @click="switckNav(index)"
          >{{ item.name }}</span>
        </div>
        <div class="main">
          <swiper
            ref="mySwiper"
            :options="swiperOption"
            class="swiper-wrapper"
          >
            <swiper-slide>
              <Introduction
                v-if="showNav.indexOf(0) != -1"
                :courseType="courseType"
                :info="info"
              ></Introduction>
            </swiper-slide>
            <swiper-slide>
              <Directory
                v-if="showNav.indexOf(1) != -1 "
                :courseType="courseType"
                :info="info"
              ></Directory>
            </swiper-slide>
            <swiper-slide>
              <Evaluation
                v-if="showNav.indexOf(2) != -1"
                :courseType="courseType"
                v-on:EvaluationCallback="EvaluationCallback"
                :businesstype="businesstype"
                :adjcourseid="adjcourseid"
              ></Evaluation>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
    <div class="button">
      <div class="collect">
        <i @click="opation('collection')">
          <img
            v-if="info.collection=='Y'"
            src="@/assets/img/h5/collect.png"
            alt
          />
          <img
            v-else
            src="@/assets/img/h5/notCollect.png"
            alt
          />
        </i>
        <p>收藏</p>
      </div>
      <button
        class="order"
        @click="opation('submit')"
        v-if="info.availablecountFlag=='1000'"
      >{{info.price?'立即报名 ¥'+info.price:'免费报名'}}</button>
      <button
        class="pause"
        v-if="info.availablecountFlag!='1000'"
      >{{info.availablecountFlag=='1001'?'名额已满':'报名截止'}}</button>
    </div>
  </div>
</template>

<script>
import Cousertop from "./courseDetails/couserTop";
import Introduction from "./courseDetails/courseIntroduction";
import Directory from "./courseDetails/courseDirectory";
import Evaluation from "./courseDetails/courseEvaluation";
import Download from "@/components/download.vue";

export default {
  metaInfo() {
    return {
      title: "课程详情",
    };
  },
  name: "belowCourseDetails",
  data() {
    return {
      classesList: [],
      navList: [{ name: "简介" }, { name: "课表" }, { name: "评价" }],
      navIndex: 0,
      showNav: [0],
      swiperOption: {
        autoHeight: true,
        onSlideChangeEnd: function (swiper) {
          this.switckNav(swiper.activeIndex);
        }.bind(this),
      },
      courseType: 4000, //1000 付费课程  ， 1001 公益课程  , 4000线下课程
      info: "", //course数据
      adjcourseid: "",

      tagsList: "",
      businesstype: 1005,
    };
  },
  components: {
    Cousertop,
    Introduction,
    Directory,
    Evaluation,
    Download,
  },
  mounted() {
    this.adjcourseid = this.$route.query.adjcourseid;
    if (this.adjcourseid) {
      this.getCourseDetail();
    }
  },
  methods: {
    switckNav(index) {
      var _this = this;
      this.navIndex = index;
      this.showNav.indexOf(index) == -1 ? this.showNav.push(index) : "";
      this.$refs.mySwiper.swiper.slideTo(index, 200, false);
      setTimeout(function () {
        _this.$refs.mySwiper.swiper.update();
      }, 300);
    },

    getCourseDetail() {
      var obj = { adjcourseid: this.adjcourseid };
      this.$post(
        "gart-common-api/api/scm/adjcourse/queryAdjCourseDetail",
        obj
      ).then((res) => {
        if (res.code == 1) {
          this.info = res.data;
          this.classesList = [res.data.lclasscode]
          var tagsList = this.info.tags?this.info.tags.split(","):[];
          for (let i = 0; i < tagsList.length; i++) {
            this.classesList.push({ tag: tagsList[i] });
          }
          this.shareLink();
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },

    opation(type) {
      switch (type) {
        case "collection":
        case "submit":
          this.util.downLoad(this, { open: true });
          break;

        default:
          break;
      }
    },

    shareLink() {
      var _this = this;
      var url =
        _this.$store.state.state.shareUrl +
        "#/h5/course/belowCourseDetails?adjcourseid=" +
        _this.adjcourseid;
      var data = {
        title: this.info.sharetitle,
        desc: this.info.sharesummary ? this.info.sharesummary : "", // 分享描述
        url: url,
        imgUrl: this.info.shareicon,
      };
      this.util.shareLink(_this, data).then(function () { });
    },
  },
};
</script>

<style lang="scss" scoped>
.belowCourseDetailsBox {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  background: #f6f7f8;
  .downLoadBox {
    // position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 2;
  }
  .mainBox {
    flex: 1;
    overflow: auto;
    position: relative;
    .content {
      margin-top: 10px;
      display: flex;
      flex-direction: column;
      background: #ffffff;
      padding-top: 11px;
      .nav {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        span {
          position: relative;
          font-size: 16px;
          line-height: 24px;
          font-weight: bolder;
          color: #a1aab3;
          font-weight: bold;
          padding: 7px 0;
        }
        span.active {
          color: #1f262e;
        }

        span.active::before {
          content: " ";
          display: inline-block;
          position: absolute;
          left: 50%;
          margin-left: -6px;
          bottom: 0;
          width: 12px;
          height: 3px;
          background: #333d47;
          border-radius: 2px;
        }
      }
      .main {
        flex: 1;
        overflow: auto;
      }
    }
  }
  .button {
    width: 100%;
    background: #ffffff;
    padding: 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.06);
    z-index: 2;
     .collect {
      padding: 0 25px 0 9px;
      i {
        display: block;
        width: 24px;
        height: 24px;
        img {
          display: block;
          width: 24px;
          height: 24px;
        }
      }
      p {
        margin-top: 4px;
        font-size: 12px;
        line-height: 17px;
        color: #a1aab3;
      }
    }
    button {
      flex: 1;
      color: #ffffff;
      font-size: 14px;
      line-height: 20px;
      font-weight: bold;
      border-radius: 24px;
      height: 48px;
    }
    .order {
        background: linear-gradient(315deg, #d44c48 0%, #ee816d 100%);
    }
    .pause {
      background: #ced3d9;
    }
  }
}
</style>>